<template>
    <div>
        <div class="small-txt mb-3">
            {{ trans[locale].no_of_selected }} <span class="font-weight-bold">{{ no_of_selected }}</span>
        </div>
        <picker-option
                :initial_year="init_year"
                :year_options="init_year_options"
                :category_options="init_category_options"
        ></picker-option>

        <album-selector :init_sorting_options="init_album_sorting_options"
                        :init_sorting="sorting"
                        v-show="!show_media_selector"></album-selector>

        <media-selector v-if="show_media_selector"
                        :init_sorting_options="init_media_sorting_options"
                        :init_sorting="sorting"
                        :init_selected_media="selected_media"></media-selector>
    </div>
</template>
<script>
    import { helperCommon } from "../../mixins/helper.common";
    import PickerOption from "./PickerOption";
    import AlbumSelector from "./AlbumSelector";
    import MediaSelector from "./MediaSelector";
    export default {
        mixins: [ helperCommon ],
        data() {
            return Object.assign({
                trans: {
                    'zh-HK': {
                        no_of_selected: '已選擇的數量 : ',
                    },
                    'en': {
                        no_of_selected: 'Selected quantity : ',
                    },
                },
                show_album_selector: false,
                selected_category: {},
                show_media_selector: false,
                selected_media: this.init_selected_media,
            }, { locale: window.locale })
        },
        components: {
            PickerOption,
            AlbumSelector,
            MediaSelector
        },
        computed: {
            no_of_selected() {
                return _.size(this.selected_media);
            },
            sorting() {
                return _.first(this.init_album_sorting_options);
            }
        },
        props: {
            init_year: {
                required: false,
                type: String,
                default: '',
            },
            init_year_options: {
                required: false,
                type: Array,
                default: () => {
                    return []
                }
            },
            init_category: {
                required: false,
                type: String,
                default: '',
            },
            init_category_options: {
                required: false,
                type: Array,
                default: () => {
                    return [];
                }
            },
            init_selected_media: {
                required: false,
                type: Array,
                default: () => {
                    return [];
                }
            },
            init_album_sorting_options: {
                required:false,
                type: Array,
                default: () => {
                    return [];
                }
            },
            init_media_sorting_options: {
                required:false,
                type: Array,
                default: () => {
                    return [];
                }
            },
        },
        beforeMount() {
            window.eventHub.$off('set-selected-media', this.setSelectedMedia);
            window.eventHub.$off('show-media-listing', this.toggleMediaListing);
        },
        mounted() {
            window.eventHub.$on('set-selected-media', this.setSelectedMedia);
            window.eventHub.$on('show-media-listing', this.toggleMediaListing);
        },
        methods: {
            toggleMediaListing(status) {
                this.show_media_selector = status;
            },
            setSelectedMedia(param) {
                this.selected_media = param.selected_media;
                window.eventHub.$emit('retrieve-selected-media', param);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/DigitalChannelMediaPicker/DigitalChannelMediaPicker.vue